export default "__VITE_ASSET__35e44b6a__"